import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from "core/typography/Typography";

const InvalidMissionPage = () => {
  const intl = useIntl();
  const message = _.chain(
    intl.formatMessage({
      id: "evalution_not_found_message",
      defaultMessage: "Evaluation does not exist",
    })
  )
    .split("\n")
    .map((part, index) => <div key={index}>{part}</div>)
    .value();

  return (
    <>
      <Typography
        className="title-2 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="evalution_not_found"
            defaultMessage="Evaluation does not exist"
          />
        }
      />
      <div className="separator-title"></div>

      <div className="justify-content-space-between">
        <div className="info-text" style={{ maxWidth: "60%" }}>
          {message}
        </div>
        <div style={{ maxWidth: "50%" }}>
          <img src={"/static/img/dav_logo.png"} alt="davidson-logo" />
        </div>
      </div>
    </>
  );
};

export default InvalidMissionPage;
